/**
 * Convert an array of objects to a CSV Blob. No external libraries.
 * @param {object[]} rows
 * @param {string[]} headers - ordered list of keys
 * @param {string[]} [labels] - human-readable column labels (defaults to headers)
 * @returns {Blob}
 */
export function arrayToCsvBlob(rows, headers, labels) {
  const esc = v => {
    const s = v == null ? '' : String(v);
    return s.includes(',') || s.includes('"') || s.includes('\n') ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const head = (labels || headers).map(esc).join(',');
  const body = rows.map(r => headers.map(h => esc(r[h])).join(',')).join('\n');
  return new Blob([head + '\n' + body], { type: 'text/csv;charset=utf-8' });
}

/**
 * Trigger a browser download for a Blob.
 */
export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
